module.exports = __webpack_public_path__ + "static/media/S4C3.56604c11.svg";